module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAAXNSR0IArs4c6QAAAChJREFUKFNjZMAFjof+Z7BczYhNGqsgWOGI0wTyMIlgNPSgAUZWQAAAVC0mKXNCYuMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_green.png
// module id = 6nRM
// module chunks = 1